import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Confirmar", -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = {
  class: "ss-card",
  style: {"padding":"0px"}
}
const _hoisted_4 = ["title"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = {
  key: 3,
  class: "ss-table-apresentacao-mobile"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("b", null, "T.DOC:", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("b", null, "N.Identificação:", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("b", null, "Documento Fiscal:", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("b", null, "Pessoa:", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("b", null, "Vencimento:", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("b", null, "Valor:", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("b", null, "Conta:", -1)
const _hoisted_15 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_17 = { class: "ant-row" }
const _hoisted_18 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_19 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_21 = { class: "ant-row" }
const _hoisted_22 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_23 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_busca_geral = _resolveComponent("busca-geral")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_totalizador = _resolveComponent("totalizador")!
  const _component_card = _resolveComponent("card")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    title: _ctx.props.tituloTela,
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    centered: "",
    width: "100%",
    "wrap-class-name": _ctx.storeSistema.state.layoutMobile?'scroll-modal ss-modal-financeiro':'full-modal ss-modal-financeiro',
    destroyOnClose: true
  }, {
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", null, [
        (((_ctx.props.obrigarSelecaoValorEspecifico === 0 && _ctx.state.quantidadeTitulosSelecionados > 0) || (_ctx.props.obrigarSelecaoValorEspecifico > 0 && _ctx.props.obrigarSelecaoValorEspecifico === _ctx.state.totalTitulosSelecionados)))
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "ant-btn ant-btn-lg ant-btn-primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.confirmar()))
            }, _hoisted_2))
          : _createCommentVNode("", true)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_form, { layout: "vertical" }, {
        default: _withCtx(() => [
          _createVNode(_component_busca_geral, {
            empresas: [_ctx.props.empresa],
            ordenacao: _ctx.telaBase.ordenacaoSelecionada,
            "onUpdate:ordenacao": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.telaBase.ordenacaoSelecionada) = $event)),
            buscaRapida: _ctx.state.buscaRapida,
            "onUpdate:buscaRapida": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.buscaRapida) = $event)),
            buscaAvancada: _ctx.state.buscaAvancada,
            "onUpdate:buscaAvancada": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.buscaAvancada) = $event)),
            onBuscarDados: _ctx.buscarTitulos,
            placeholder: 'Busca rápida: Digite o número de identificação, data, valor ou alguma informação da pessoa para localizarmos o que você procura...'
          }, null, 8, ["empresas", "ordenacao", "buscaRapida", "buscaAvancada", "onBuscarDados", "placeholder"]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_a_table, {
              columns: _ctx.gradeBase.colunas.filter(item => item.visible),
              "data-source": _ctx.state.titulos,
              rowKey: "codigo",
              pagination: false,
              loading: _ctx.telaBase.carregando,
              scroll: _ctx.storeSistema.state.layoutMobile ? null : { x: (_ctx.gradeBase.windowWidth), y: _ctx.defineAlturaScroll(50) },
              "row-selection": { selectedRowKeys: _ctx.gradeBase.codigosSelecionados, onChange: _ctx.mudarSelecao },
              size: "small"
            }, {
              bodyCell: _withCtx(({ column, record, text }) => [
                (column.key === 'TipoDocumentoFinanceiro')
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      title: record.descricaoTipoDocumentoFinanceiro
                    }, _toDisplayString(record.siglaTipoDocumentoFinanceiro), 9, _hoisted_4))
                  : _createCommentVNode("", true),
                (column.customRenderRow === _ctx.ECustomRenderRow.MascararData)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(text)), 1))
                  : (column.customRenderRow === _ctx.ECustomRenderRow.MascararFracionado)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text)), 1))
                    : (column.key === 'TituloFinanceiro')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createElementVNode("span", null, [
                            _hoisted_8,
                            _createTextVNode(" " + _toDisplayString(record.siglaTipoDocumentoFinanceiro + ' - ' +
                  record.descricaoTipoDocumentoFinanceiro), 1)
                          ]),
                          _createElementVNode("span", null, [
                            _hoisted_9,
                            _createTextVNode(" " + _toDisplayString(record.numeroTitulo), 1)
                          ]),
                          _createElementVNode("span", null, [
                            _hoisted_10,
                            _createTextVNode(" " + _toDisplayString(record.numeroDocumentoFiscal), 1)
                          ]),
                          _createElementVNode("span", null, [
                            _hoisted_11,
                            _createTextVNode(" " + _toDisplayString(record.nomePessoa), 1)
                          ]),
                          _createElementVNode("span", null, [
                            _hoisted_12,
                            _createTextVNode(" " + _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(record.dataVencimento)), 1)
                          ]),
                          _createElementVNode("span", null, [
                            _hoisted_13,
                            _createTextVNode(" R$ " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.saldo, 2)), 1)
                          ]),
                          _createElementVNode("span", null, [
                            _hoisted_14,
                            _createTextVNode(" " + _toDisplayString(record.descricaoConta), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true)
              ]),
              emptyText: _withCtx(() => [
                _createVNode(_component_mensagem_sem_dados, {
                  resultadoPesquisa: !_ctx.telaBase.carregando,
                  mensagem: _ctx.telaBase.carregando ? 'Buscando informações, por favor aguarde...' : 'Nenhum título foi encontrado com estes filtros!'
                }, null, 8, ["resultadoPesquisa", "mensagem"])
              ]),
              _: 1
            }, 8, ["columns", "data-source", "loading", "scroll", "row-selection"])
          ]),
          (!_ctx.props.apenasUmTitulo)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_card, {
                    class: "ss-card-alinhado",
                    titulo: "TÍTULOS ENCONTRADOS"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createVNode(_component_totalizador, {
                            titulo: "QUANTIDADES",
                            valor: _ctx.state.quantidadeTitulos,
                            casasDecimais: 0
                          }, null, 8, ["valor"])
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          _createVNode(_component_totalizador, {
                            titulo: "TOTAL TÍTULOS",
                            monetario: true,
                            valor: _ctx.state.totalTitulos
                          }, null, 8, ["valor"])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_card, {
                    class: "ss-card-alinhado",
                    titulo: "TÍTULOS SELECIONADOS"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _createVNode(_component_totalizador, {
                            titulo: "QUANTIDADES",
                            valor: _ctx.state.quantidadeTitulosSelecionados,
                            casasDecimais: 0
                          }, null, 8, ["valor"])
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _createVNode(_component_totalizador, {
                            titulo: "TOTAL TÍTULOS",
                            monetario: true,
                            valor: _ctx.state.totalTitulosSelecionados
                          }, null, 8, ["valor"])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title", "visible", "wrap-class-name"]))
}